export default __webpack_public_path__ + "static/buenos-9a4fd51a316ce5bd49606ecd4898fcf4.jpeg";